class Download {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  bindEvents() {
    if (this.ui.$buttons) {
      this.ui.$buttons.forEach(($button) => {
        $button.addEventListener('click', this.onClick.bind(this));
      });
    }
  }

  bindUI() {
    this.ui = {};
    this.ui.$linkParent = this.element.querySelector('[data-ref="link-parent"]');
    this.ui.$links = [...this.element.querySelectorAll('[data-ref="link"]')];
    this.ui.$buttons = [];
  }

  createButtons() {
    const $links = this.ui.$links.filter(($link) => {
      return !$link.href.includes('#');
    });

    $links.reverse();

    $links.forEach(($link) => {
      const $button = document.createElement('button');
      $button.className = $link.className;
      $button.classList.add('btn');
      $button.setAttribute('role', 'button');
      $button.setAttribute('type', 'button');
      $button.setAttribute('data-ref', 'button');
      $button.setAttribute('data-link', $link.href);
      $button.append(
        ...[...$link.childNodes].map(($child) => $child.cloneNode(true)),
      );

      $link.parentElement.prepend($button);
      $link.remove();

      this.ui.$buttons.push($button);
    });
  }

  initialize() {
    this.bindUI();
    this.createButtons();
    this.bindEvents();
  }

  onClick(e) {
    const url = e.currentTarget.getAttribute('data-link');
    const a = document.createElement('a');
    a.href = url;
    a.download = url.split('/').pop();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}

export default Download;
